import { alpha, styled } from "@mui/material/styles";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";

const DateRangePickersDay = styled((props) => {
  const { inRange, inHoveredRange, isStartDate, isEndDate, ...otherProps } =
    props;

  const className = [
    props.className,
    inRange ? " InRange" : "",
    inHoveredRange ? " InHoveredRange" : "",
    isStartDate ? " StartDate" : "",
    isEndDate ? " EndDate" : "",
  ].join(" ");

  const pickersDateClassName = [
    props.className,
    isStartDate || isEndDate ? " Mui-selected" : "",
  ].join(" ");

  return (
    <div className={className}>
      <PickersDay
        {...otherProps}
        className={pickersDateClassName}
        selected={false}
      />
    </div>
  );
})(
  ({ theme }) => `
  &.InHoveredRange {
    background-color: ${alpha(theme.palette.secondary.main, 0.1)};
  }

  &.InRange {
    background-color: ${alpha(theme.palette.secondary.main, 0.1)};
  }

  &:first-of-type,
  &.StartDate {
    border-top-left-radius: 50%;
    border-bottom-left-radius: 50%;
  }

  &:last-of-type,
  &.InHoveredRange:hover,
  &.EndDate {
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
  }
  `,
);

export default DateRangePickersDay;
